import React from "react";
import { MdOutlineDelete } from "react-icons/md";
import Vector from "../../../../asesst/Vector.svg";

const MasterTable = ({
  MasterHeading,
  currentItems,
  indexOfFirstItem,
  editRowId,
  editedData,
  handleInputChange,
  handleSaveChanges,
  handleEditDetails,
  handleDeleteClick,
}) => {
  return (
    <div className="bg-white rounded-2xl shadow-sm p-4 sm:p-6">
      <div className="overflow-x-auto lg:max-h-[600px] max-h-96">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="sticky top-0 bg-[#F1F4F9]">
            <tr>
              {MasterHeading.map((head) => (
                <th
                  key={head.name}
                  scope="col"
                  className="px-6 py-3 text-left text-base font-medium text-[#202224] uppercase tracking-wider"
                >
                  {head.name}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {currentItems?.map((item, index) => (
              <tr key={item?._id}>
                <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-500">
                  {indexOfFirstItem + index + 1}
                </td>

                <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-900">
                  {editRowId === item?._id ? (
                    <input
                      type="text"
                      name="name"
                      value={editedData.name}
                      onChange={handleInputChange}
                      className="border border-gray-300 rounded-lg px-2 py-1 w-full"
                    />
                  ) : (
                    item?.name
                  )}
                </td>

                <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-500">
                  {editRowId === item?._id ? (
                    <input
                      type="text"
                      name="sequence"
                      value={editedData.sequence}
                      onChange={handleInputChange}
                      className="border border-gray-300 rounded-lg px-2 py-1 w-full"
                    />
                  ) : (
                    <p>{item?.sequence || "-"}</p>
                  )}
                </td>

                <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-900">
                  {editRowId === item?._id ? (
                    <select
                      name="status"
                      value={editedData.status}
                      onChange={handleInputChange}
                      className="border border-gray-300 rounded-lg px-2 py-1 w-full"
                    >
                      <option value={1}>Active</option>
                      <option value={2}>Inactive</option>
                    </select>
                  ) : (
                    <span
                      className={`px-4 py-1 w-[70px] inline-flex text-xs leading-5 font-base rounded-full ${
                        item?.status === 1
                          ? "bg-[#467FE4] text-[#FFFFFF]"
                          : "bg-[#FB8787] text-[#FFFFFF]"
                      }`}
                    >
                      {item?.status === 1 ? "Active" : "Inactive"}
                    </span>
                  )}
                </td>

                <td className="px-6 py-3 whitespace-nowrap text-sm">
                  {editRowId === item?._id ? (
                    <button
                      onClick={handleSaveChanges}
                      className="bg-[#1C3664] text-white px-4 py-2 rounded-lg"
                    >
                      Save Changes
                    </button>
                  ) : (
                    <div className="flex items-center">
                      <span
                        onClick={() => handleEditDetails(item)}
                        className="text-[#1C3664] text-base font-poppins flex items-center cursor-pointer mr-4"
                      >
                        <img src={Vector} alt="edit details" className="mr-1" />
                      </span>
                      <span
                        onClick={() => handleDeleteClick(item?._id)}
                        className="text-red-600 text-base font-poppins flex items-center cursor-pointer"
                      >
                        <MdOutlineDelete size={24} />
                      </span>
                    </div>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default MasterTable;